<svg #svgIcon>
  <use attr.xlink:href="assets/2022/icons/icons.svg#{{iconName}}"></use>
</svg>
